

import React, { useState, useEffect } from "react";
import axios from 'axios';
import { aPIURL } from '../utils/common';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DebitNote =()=>
{
   let [payMode,setPayMode]=useState(0);
    const [customerData, setCustomerData]= useState([]);   
    const [invoiceNoData, setInvoiceNoData]= useState([]);   
    const [payModeData, setPayModeData]= useState([]);  
    const [paymentTrnData, setPaymentTrnData]= useState([]);  
    const API_URL=aPIURL();
    let [custID, setCustID]=useState(0);
    const [invoiceID, setInvoiceID]=useState(0);
    const [inputs, setInputs] = useState({});
    let [min_Date,setMin_Date]= useState("");
    let [max_Date,setMax_Date]= useState("");
    const [order, setOrder] = useState("ASC");
    let [receiveAmt, setReceiveAmt]= useState(0);


useEffect(() => {

    getSevenDaysAgoDate();
    const curls=API_URL+`GpsSaleCustomerList/`;     
    axios.post(curls).then(response => {        
          setCustomerData(response.data.data);                       
    }).catch(function(error) { console.log(error.message); });      
        
    const purls=API_URL+`GetPaymentMode/`;     
    axios.get(purls).then(response => {        
        setPayModeData(response.data.data);                       
    }).catch(function(error) { console.log(error.message); });       
  }, []);

const getSevenDaysAgoDate = () => 
 {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    setMin_Date(date.toISOString().split('T')[0]);
    const mdate = new Date();
    mdate.setDate(mdate.getDate());
    setMax_Date(mdate.toISOString().split('T')[0]);

    //set today date as default date starts
    var now = new Date();
    var month = (now.getMonth() + 1);               
    var day = now.getDate();
    if (month < 10) 
    month = "0" + month;
    if (day < 10) 
    day = "0" + day;
    var today = now.getFullYear() + '-' + month + '-' + day;
    inputs.invoicedate = today;
    //set today date as default date ends    
 };

const ChangeCustomerID = (e) => 
{
       
    setCustID(e.target.value);   
    setInvoiceID(0);
    setPayMode(0);
    setReceiveAmt(0);
    inputs.refNumber='';
    inputs.receivedBy='';  
    setPaymentTrnData([]);   
    setInvoiceNoData([]);
    let invurl = API_URL+`GetInvoiclistbyeCustID/0/3`;
    
    axios.get(invurl).then(response => {
       setInvoiceNoData(response.data.data);    
    }).catch(function(error) { console.log(error.message); });   
}

const ChangeInvoiceNo=(e)=>
{
    setInvoiceID(e.target.value);  
    setPayMode(0);
    setReceiveAmt(0);
    inputs.refNumber='';
    inputs.receivedBy='';    
    inputs.invoicedate= max_Date;

    let invnourl = API_URL+`GetPaymentDetailByInvoiceID?Id=0&InvType=${e.target.value}&AccountID=${custID}`;    
    axios.get(invnourl).then(response => 
        {
            if(response.data.data.length>0)
            {
                 if(response.data.data[0].id>0)
                 {
                        setPaymentTrnData(response.data.data);
                         setReceiveAmt(response.data.data[0].tReceiveAmt);
                 }
                 else
                 {
                        setPaymentTrnData([]);
                 }                  
            }         
        }).catch(function(error) { console.log(error.message); });          
   
}
const sorting=(col)=>
{
  try
  {
    if(order==="ASC")
    {
            const sorted=[...paymentTrnData].sort((a,b)=>
            a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
            );
            setPaymentTrnData(sorted);
            setOrder("DSC");
    }
    if(order==="DSC")
    {
            const sorted=[...paymentTrnData].sort((a,b)=>
            a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
            );
            setPaymentTrnData(sorted);
            setOrder("ASC");
    }  }
  catch(error) 
  {
    console.log(error.message);
  }           
}
const changeVHandler = (event) => {
 
  if(event.target.name==='paidAmt')
  {
        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) 
        {
         
              const name = event.target.name;             
              const value = event.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['paidAmt']: ""}))
              
        }
        
  }
else
  {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({...values, [name]: value}))     
  }      
}
const ChangePayMode=(event)=>
{
     setPayMode(event.target.value);     
}
const SaveBtnClick=()=>
{
    if (custID === 0) 
    {
        toast.error('Please Select Customer.')
        return
    }
    else if (invoiceID===0)
    {
        toast.error('Please Select Advance Against.')
        return
    } 
    else if(payMode === 0)
    {
        toast.error('Please Select Payment Mode.')
        return
    }
    else if(inputs.invoicedate==='' || (!inputs.invoicedate))
    {
        toast.error('Please Provide Invoice Date.')
        return
    }
    else if(inputs.paidAmt ==='0' || inputs.paidAmt ==='' || (!inputs.paidAmt))
    {
        toast.error('Please Provide Amount.')
        return
    }
    else if(parseFloat(inputs.paidAmt)<0)
    {
        toast.error('Please Provide valid Amount.')
        return
    }
    else if(inputs.receivedBy ==='' || (!inputs.receivedBy))
    {
        toast.error('Please Provide Received By.')
        return
    }   
    else
    {
         const params = JSON.stringify({           
                "receiptDate": inputs.invoicedate,
                "type": "DR",
                "accountID": parseInt(custID),
                "invoiceID": 0,
                "pModeID": payMode,
                "receiveAmt": inputs.paidAmt,
                "reference": inputs.refNumber,
                "receivedBy": inputs.receivedBy,
                "iS_Active": true,
                "createdBy": "Admin",
                "invoiceType": invoiceID        
         });
         
         //Invoice Payment Insert start        
         axios.post(API_URL+'PaymentReceiveInsert', params, {
           
            "headers": 
             {
                 "content-type": "application/json",    
             },
             })
             .then(function (response) 
             {
                
                     if(!response.data.validStatus)
                     {
                            toast.error(response.data.message);                                                                 
                     }
                     else
                     {
                              setPayMode(0);
                              setReceiveAmt(0);
                              inputs.refNumber='';
                              inputs.receivedBy='';
                              inputs.paidAmt='';  
                              let invnourl1 = API_URL+`GetPaymentDetailByInvoiceID?Id=0&InvType=${invoiceID}&AccountID=${custID}`;  
                              axios.get(invnourl1).then(response => 
                              {
                                    if(response.data.data.length>0)
                                    {
                                         if(response.data.data[0].id>0)
                                            {
                                                setPaymentTrnData(response.data.data);
                                                 setReceiveAmt(response.data.data[0].tReceiveAmt);
                                            }
                                             else
                                            {
                                                setPaymentTrnData([]);
                                                 setReceiveAmt(0);
                                            }                                     
                                     }                                   
                                    }).catch(function(error) { console.log(error.message); });  

                                             toast.success(response.data.message);                                                       
                                    }      
                                    })
                                    .catch(function (error) 
                                    {
                                        toast.error("Some Error occured while saving sale device record,Please Provide Valid Inputs.");                  
                                        console.log(error.message);    
                                     });
    }       
}
return(
<>  
   <div className="top-bar clearfix">
    <div className="row">
    <div className="col-md-4">
    <h2> Debit Note </h2>             
    </div></div></div>      
    <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body">
    <div class="row align-items-end">  
    <div className='col-md-4 col-lg-3 form-group'>
    Customer <span style={{color:"red"}}>&nbsp;*</span>
    <select className="form-control"  name="DCustomerID" value={custID} onChange={ChangeCustomerID} >
    <option value={0}>------ Select Customer ------</option>
    {customerData.map((e, key) => {
    return <option key={key} value={e.accountID}>{e.customerName}</option>;
    })}
    </select>
    </div>
    <div className='col-md-4 col-lg-3 form-group'>
    Advance Against <span style={{color:"red"}}>&nbsp;*</span>                   
    <select className="form-control"  name="invoiceno" value={invoiceID} onChange={ChangeInvoiceNo} >
    <option value={0}>------ Select Advance Against------</option>
    {invoiceNoData.map((e, key) => {
    return <option key={key} value={e.invoiceID}>{e.invDetailID}</option>;
    })}
    </select>
    </div>
    <div className='col-md-4 col-lg-3 form-group'>
    Debit Amount <span style={{color:"red"}}>&nbsp;*</span>
    <input name="receiveAmt"  type="text"   className="form-control"  value={receiveAmt}  disabled={true} />
    </div>   
      <div className='col-md-4 col-lg-3 form-group'>
    Date  <span style={{color:"red"}}>&nbsp;*</span>
    <input name="invoicedate"  type="date" className="form-control"  value={inputs.invoicedate}  min={min_Date} max={max_Date} onChange={changeVHandler}/>
    </div>
    <div className='col-md-4 col-lg-3 form-group'>
    Payment Mode <span style={{color:"red"}}>&nbsp;*</span>
    <select className="form-control" name="paymodes"  value={payMode} style={{"backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px"}} onChange={ ChangePayMode }  >
    <option value={0}>------ Select Payment Mode ------</option> 
    {payModeData.map((e, key) => {
    return <option key={key} value={e.id}>{e.payMode}</option>;
    })}     
    </select> 
    </div>
   
    <div className='col-md-4 col-lg-3 form-group'>
    Amount <span style={{color:"red"}}>&nbsp;*</span>
    <input name="paidAmt"  type="text"  maxLength={10} className="form-control"  value={inputs.paidAmt}  onChange={changeVHandler}/>
    </div>    
    <div className='col-md-4 col-lg-3 form-group'>
    Ref No. 
    <input name="refNumber"  type="text"  maxLength={200} className="form-control"  value={inputs.refNumber}  onChange={changeVHandler}/>
    </div>  
     <div className='col-md-4 col-lg-3 form-group'>
    Received By <span style={{color:"red"}}>&nbsp;*</span>  
    <input name="receivedBy"  type="text"   className="form-control"  maxLength={50}  value={inputs.receivedBy} onChange={changeVHandler}></input>    
    </div>                             
    <div className='col-md-12 col-lg-12 form-group' style={{ "padding-top":"27px"}}>
    <center><button className="btn btn-primary2" onClick={() => SaveBtnClick()}>Save</button>   </center>
    </div>      
    <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
    </div > </div > </div>     
    <div className="container-fluid p-3">
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body p-0">
  <table  id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
  <thead>
  <tr>    
               <th style={{textAlign:"center"}}>S.No. </th>  
               <th onClick={()=>sorting("invoiceID") } style={{textAlign:"center","cursor": "pointer"}}>Advance Against &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>  
               <th onClick={()=>sorting("receiptNo") } style={{textAlign:"center","cursor": "pointer"}}>Receipt No &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>        
               <th onClick={()=>sorting("receiptDate") } style={{textAlign:"center","cursor": "pointer"}}>Receipt Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
               <th onClick={()=>sorting("receiveAmt") } style={{textAlign:"center","cursor": "pointer"}}>Amount &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i> </th>
               <th onClick={()=>sorting("pModeID") } style={{textAlign:"center","cursor": "pointer"}}>Payment Mode &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
               <th onClick={()=>sorting("reference") } style={{textAlign:"center","cursor": "pointer"}}>Reference No &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
               <th onClick={()=>sorting("receivedBy") } style={{textAlign:"center","cursor": "pointer"}}>Received By &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                
  </tr>
  </thead>
  <tbody>
    {paymentTrnData.map((pdata) => {
              return (                  
              <tr key={pdata.id}>
              <td style={{textAlign:"center"}}>{pdata.id}</td>   
              <td style={{textAlign:"center"}}>{pdata.invoiceID}</td>   
              <td style={{textAlign:"center"}}>{pdata.receiptNo}</td> 
              <td style={{textAlign:"center"}}>{pdata.receiptDate}</td>
              <td style={{textAlign:"right"}}>{pdata.receiveAmt}</td>
               <td style={{textAlign:"center"}}>{pdata.pModeID}</td>             
              <td>{pdata.reference}</td>
              <td>{pdata.receivedBy}</td>         
              </tr>           
            );
          })} 
            </tbody>
          </table>    
          </div> </div></div></div> 
          <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>          
   </>      
    )
};
export default DebitNote;


